export function LoadingText(text) {
  if (!text || (typeof(text) == "string" && text.includes("undefined"))) {
    return (
      <div className="loading inline-block"></div>
    );
  }
  return <div className="inline">{text}</div>;
}